import * as L from 'leaflet';
import { GetRouteNetworksInAreaReq } from '../interfaces/map-data';
import { RouteSheetSize } from '../constants/constants';

export default class MapUtils {
  static getPanningBoundariesByZoomLevel(zoom: number): { lat: number; lng: number } {
    let lat: number;
    let lng: number;

    switch (zoom) {
      case 11:
        lat = 0.14;
        lng = 0.28;
        break;
      case 12:
        lat = 0.13;
        lng = 0.25;
        break;
      case 13:
        lat = 0.12;
        lng = 0.22;
        break;
      case 14:
        lat = 0.11;
        lng = 0.2;
        break;
      default:
        lat = 0.15;
        lng = 0.3;
        break;
    }
    return { lat, lng };
  }

  static getMapBoundsForNetworks(map: L.Map): GetRouteNetworksInAreaReq {
    const bounds = map.getBounds();
    const zoom = map.getZoom();
    const panningBoundaries = MapUtils.getPanningBoundariesByZoomLevel(zoom);

    const boundsForNetworks: GetRouteNetworksInAreaReq = {
      MinLat: bounds.getSouthWest().lat - panningBoundaries.lat,
      MaxLat: bounds.getNorthEast().lat + panningBoundaries.lat,
      MinLon: bounds.getSouthWest().lng - panningBoundaries.lng,
      MaxLon: bounds.getNorthEast().lng + panningBoundaries.lng,
    };

    return boundsForNetworks;
  }

  /** only pans or zooms out, not past minZoom */
  static showBoundsBesideRouteSheet(
    map: L.Map,
    bounds: L.LatLngBounds,
    padding = 32,
    minZoom = 11,
  ): void {
    const { left, bottom } = MapUtils.getRouteSheetInsets(map);
    const size = map.getSize();
    const northWest = map.latLngToContainerPoint(bounds.getNorthWest());
    const southEast = map.latLngToContainerPoint(bounds.getSouthEast());
    if (
      northWest.x >= left &&
      northWest.y >= 0 &&
      southEast.x <= size.x &&
      southEast.y <= size.y - bottom
    ) {
      return;
    }

    const paddingTopLeft = L.point(left + padding, padding);
    const paddingBottomRight = L.point(padding, bottom + padding);
    const boundsZoom = map.getBoundsZoom(bounds, false, paddingTopLeft.add(paddingBottomRight));
    const zoom = Math.min(map.getZoom(), Math.max(boundsZoom, minZoom));

    const offset = paddingBottomRight.subtract(paddingTopLeft).divideBy(2);
    const center = map
      .project(bounds.getSouthWest(), zoom)
      .add(map.project(bounds.getNorthEast(), zoom))
      .divideBy(2)
      .add(offset);

    map.setView(map.unproject(center, zoom), zoom, { animate: true });
  }

  private static getRouteSheetInsets(map: L.Map): { left: number; bottom: number } {
    const mapRect = map.getContainer().getBoundingClientRect();

    if (window.matchMedia(`(max-width: ${RouteSheetSize.phoneMaxWidth}px)`).matches) {
      const sheetTop = window.innerHeight * (1 - RouteSheetSize.phoneHeightRatio);
      return { left: 0, bottom: Math.max(0, mapRect.bottom - sheetTop) };
    }

    const sheetWidth = window.matchMedia(`(max-width: ${RouteSheetSize.narrowMaxWidth}px)`).matches
      ? RouteSheetSize.narrowWidth
      : RouteSheetSize.width;
    return { left: Math.max(0, sheetWidth - mapRect.left), bottom: 0 };
  }
}
